const store = new Map();

export const cacheGet = (key) => store.get(key);
export const cacheSet = (key, value) => store.set(key, value);
